var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 26.4286,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2849 19.608C18.9231 20.7832 17.1566 21.4926 15.2263 21.4926C10.9193 21.4926 7.42773 17.9605 7.42773 13.6035C7.42773 9.24644 10.9193 5.71436 15.2263 5.71436C17.1566 5.71436 18.9231 6.42379 20.2849 7.59897C21.6467 6.42379 23.4132 5.71436 25.3434 5.71436C29.6505 5.71436 33.142 9.24644 33.142 13.6035C33.142 17.9605 29.6505 21.4926 25.3434 21.4926C23.4132 21.4926 21.6467 20.7832 20.2849 19.608Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2852 19.608C21.962 18.161 23.0252 16.0078 23.0252 13.6035C23.0252 11.1991 21.962 9.04598 20.2852 7.59896C21.647 6.42379 23.4134 5.71436 25.3437 5.71436C29.6508 5.71436 33.1423 9.24644 33.1423 13.6035C33.1423 17.9605 29.6508 21.4926 25.3437 21.4926C23.4134 21.4926 21.647 20.7832 20.2852 19.608Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2849 7.59912C21.9617 9.04613 23.0249 11.1993 23.0249 13.6036C23.0249 16.008 21.9617 18.1611 20.2849 19.6081C18.6082 18.1611 17.5449 16.008 17.5449 13.6036C17.5449 11.1993 18.6082 9.04613 20.2849 7.59912Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/MasterCardIcon.3d74a39bc7f3dc00054a1308b4399e20.svg";
export { ForwardRef as ReactComponent };